import React from 'react';

const List = () => {
  const half = Math.ceil(FAQs.length / 2);
  const col1 = FAQs.slice(0, half);
  const col2 = FAQs.slice(half);
  return (
    <div className="row">
      <div className="col-xs-12 col-sm-5 col-sm-offset-1 col-md-4 col-md-offset-2">
        <ul className="faq-list">
          {col1.map((faq, idx) => <ListItem {...faq} key={idx} />)}
        </ul>
      </div>
      <div className="col-xs-12 col-sm-5 col-md-4">
        <ul className="faq-list">
          {col2.map((faq, idx) => <ListItem {...faq} key={idx} />)}
        </ul>
      </div>
    </div>
  );
};

class ListItem extends React.Component {
  constructor(props) {
    super(props);
    this.state = { open: false };
    this.toggle = this.toggle.bind(this);
  }

  toggle(event) {
    if (event.target.tagName === 'A') return; // don't change state if clicked link
    this.setState({ open: !this.state.open });
  }

  _getMaxHeight() {
    if (!this.state.open) return '0px';

    const clone = this.answerDiv.cloneNode(true);

    const { width, fontSize, letterSpacing } = window.getComputedStyle(
      this.answerDiv
    );
    clone.style.width = width;
    clone.style.fontSize = fontSize;
    clone.style.letterSpacing = letterSpacing;

    clone.style.position = 'absolute';
    clone.style.left = '10000px'; // render off-screen
    clone.style.maxHeight = '10000px';
    clone.style.transition = null;
    document.body.appendChild(clone);
    const maxHeight = clone.clientHeight;
    clone.remove();

    return maxHeight;
  }

  render() {
    const maxHeight = this._getMaxHeight();

    return (
      <li
        className={`faq-item ${this.state.open
          ? 'faq-item--open'
          : 'faq-item--closed'}`}
        onClick={this.toggle}
      >
        <div className="faq-item__question">{this.props.question}</div>
        <div
          className="faq-item__answer"
          style={{
            maxHeight,
            overflow: 'hidden',
            transition: 'max-height 200ms ease-out'
          }}
          ref={div => {
            this.answerDiv = div;
          }}
        >
          {this.props.answer}
        </div>
      </li>
    );
  }
}

const FAQs = [
  {
    question: 'Which cities does Saucey deliver to?',
    answer: (
      <span>
        Saucey offers 30-minute alcohol delivery to{' '}
        <a href="/cities/alcohol-delivery-los-angeles/">Los Angeles</a>,{' '}
        <a href="/cities/alcohol-delivery-san-francisco/">San Francisco</a>,{' '}
        <a href="/cities/alcohol-delivery-chicago/">Chicago</a>,{' '}
        <a href="/cities/alcohol-delivery-san-diego/">San Diego</a>,{' '}
        <a href="/cities/alcohol-delivery-sacramento/">Sacramento</a>, &{' '}
        <a href="/cities/alcohol-delivery-oakland/">Oakland</a>.
      </span>
    )
  },
  { question: "Why aren't you in my city?", answer: 'Move somewhere better.' },
  {
    question: "What are Saucey's hours?",
    answer: (
      <span>
        We{"'"}re open for 30-minute delivery between the following hours,
        though you can also schedule an order in advance:
        <ul className="faq-item__list">
          <li>Mon-Thur: 12pm-11pm</li>
          <li>Fri & Sat: 12pm-1am</li>
          <li>Sun: 12pm-10pm</li>
        </ul>
        <small>* Hours vary by location and are subject to change.</small>
      </span>
    )
  },
  {
    question: 'How much is the delivery fee?',
    answer:
      "F*ck delivery fees. We wouldn't do that to you. We have simple pricing. The price you see is the price you pay, no 30-min delivery fees or order minimums!"
  },
  {
    question: 'Do I need to be 21 to order alcohol from Saucey?',
    answer:
      'Yes. We check ID, on every, single, order. As part of our delivery process, we have ID scanners that work for your Driver License, State ID, or passport. You must be 21+ to receive your delivery.'
  },
  {
    question: 'Is there an app for alcohol delivery?',
    answer: (
      <span>
        Yep! We have both an{' '}
        <a href="https://play.google.com/store/apps/details?id=com.saucey&hl=en">
          Android
        </a>{' '}
        and an{' '}
        <a href="https://itunes.apple.com/us/app/saucey-the-alcohol-delivery-app/id869556845?mt=8">
          iOS
        </a>{' '}
        app. Download for free & start getting alcohol delivered to you!
      </span>
    )
  },
  {
    question: 'How does alcohol delivery work?',
    answer:
      "You shop your favorite beer, wine, liquor & mixers. We'll deliver your order right to your door! Make sure you have your ID handy for the delivery. We'll scan your ID to verify you are 21 or older! Shipped orders require a recipient that is 21 or older to receive the package and their signature."
  },
  {
    question: 'Can Saucey provide bartenders and deliver for events?',
    answer: (
      <span>
        Planning a party and need a pro-mixologist? We{"'"}ve got you covered!
        Head over to <a href="/bartenders">www.saucey.com/bartenders</a> to
        learn more about pricing and the areas we service.
      </span>
    )
  },
  {
    question: 'Will you give me free alcohol for a year?',
    answer: (
      <span>
        Maybe, what{"'"}s in it for us? Tell us{' '}
        <a href="https://twitter.com/sauceyapp">@SauceyApp</a>
      </span>
    )
  },
  {
    question: 'When should I use Saucey?',
    answer:
      'Netflix and chill nights, adventures, birthdays, Tuesdays, bachelor parties, Sunday brunch... basically all the time.'
  }
];

export default List;



// WEBPACK FOOTER //
// ./shared/components/home/landingPage/faq.js